<a (click)="$event.preventDefault(); itemClick.emit(video)">
  <div class="cover" [class.is-selected]="isSelected">
    <img [src]="video.cover_url" [alt]="video.name" class="img" />
  </div>
</a>
